export const environment = {
  production: false,
  test: true,
  dev: false,
  baseUrl: 'https://test.api.sales.hansons.com/gbb/api/v2',
  baseUrlV1: 'https://test-api.sales.hansons.com/gbb/api/v1',
  baseMeasureUrl: 'https://test.api.measure.hansons.com/gbb/api/v2',
  baseMeasureUrlV1: 'https://test.api.measure.hansons.com/gbb/api/v1',
  clientId: 'ceaab9f2-1010-47d4-bc40-7247a0d826ea',
  authority: 'https://login.microsoftonline.com/157cd635-123b-401e-a17c-aec226d8b1d0',
  redirectUrl: 'https://test.admin.sales.hansons.com/admin/gbb/versions',
  postLogoutRedirectUri: 'http://test.admin.sales.hansons.com/login',
  environmentList: [
    { id: 'production', name: 'Production' },
    { id: 'development', name: 'Development' },
  ]
};
